import styled, { css } from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  margin-top: 75px;
  flex: 1;
  padding-top: 20px;
  position: relative;

  display: flex;
  flex-direction: column;
`

export const ButtonView = styled.div`
  width: auto;
  padding: 5px 0;

  position: fixed;
  bottom: 0;
`

export const Title = styled.h1`
  font-size: 30px;
  margin: 0;
  padding: 0;
`

export const Tabs = styled.section`
  width: 100%;
  margin-top: 20px;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`

export const Tab = styled.article`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: #0d6efd;
      font-weight: bold;
    `}

  p {
    all: unset;
    cursor: pointer;
  }
`

export const FormPage = styled.div`
  padding: 15px;
  margin-top: 20px;
`

export const Group = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
`

export const AddressSection = styled.section`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`
export const AddressTitle = styled.h5`
  text-align: center;
  font-size: 16px;
`

export const AddressFrom = styled.article`
  padding: 5px;
`

export const AddressTo = styled.article`
  padding: 5px;
`

export const ListPage = styled.div`
  padding: 15px;
  margin-top: 20px;

  p {
    text-align: center;
  }
`
